var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1235,
    height: 650,
    viewBox: "0 0 7410 3900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0h7410v3900H0",
    fill: "#b31942"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,450H7410m0,600H0m0,600H7410m0,600H0m0,600H7410m0,600H0",
    stroke: "#FFF",
    strokeWidth: 300
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0h2964v2100H0",
    fill: "#0a3161"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M247,90 317.534230,307.082039 132.873218,172.917961H361.126782L176.465770,307.082039z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    y: 420
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    y: 840
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    y: 1260
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    y: 1680
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s4",
    x: 247,
    y: 210
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s9",
    x: 494
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s18",
    x: 988
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s9",
    x: 1976
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s5",
    x: 2470
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/usa.2cd38b29c6d401d318403df9e01abc9d.svg";
export { ForwardRef as ReactComponent };